import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../assets/images/logopng-17.png";
import { UserChangePasswordApi } from "../../../services/apis/UserProfile";
import BtnLoader from "../../components/Loader/btnLoader";
import { Toaster } from "../../components/Toaster/Toster";
import { FaCircleInfo } from "react-icons/fa6";

import { useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";

function UserChangePassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [oldPassword, setOldPassword] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  // const [formdata, setFormdata] = useState({ oldPassword:"", confirmPassword:"", password:"" });
  let errorsObj = { email: "" };
  const [errors, setErrors] = useState(errorsObj);
  // const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showOldPassword, setOldShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const user = useSelector((val) => val?.userReducers?.user);

  // Validation logic
  // const validateFields = () => {
  //   const errorObj = { email: "", };
  //   let isError = false;
  //   if (!email) {
  //     errorObj.email = "Email is required";
  //     isError = true;
  //   }
  //   setErrors(errorObj);
  //   return isError;
  // };
  const validateFields = () => {
    const errorObj = {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    };
    let isError = false;

    // Validate oldPassword
    if (!oldPassword) {
      errorObj.oldPassword = "Old password is required";
      isError = true;
    }

    // Validate password
    if (!password) {
      errorObj.password = "New password is required";
      isError = true;
    } else if (password.length < 8) {
      errorObj.password = "Password must be at least 8 characters";
      isError = true;
    }

    // Validate confirmPassword
    if (!confirmPassword) {
      errorObj.confirmPassword = "Confirm password is required";
      isError = true;
    } else if (confirmPassword !== password) {
      errorObj.confirmPassword = "Passwords do not match";
      isError = true;
    }

    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    if (field === "oldPassword") {
      setOldPassword(e.target.value);
      if (submitted && errors.oldPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, oldPassword: "" }));
      }
    }

    if (field === "password") {
      setPassword(e.target.value);
      if (submitted && errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }

    if (field === "confirmPassword") {
      setConfirmPassword(e.target.value);
      if (submitted && errors.confirmPassword) {
        setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: "" }));
      }
    }
  };

  const onLogin = async (e) => {
    console.log(
      oldPassword,
      password,
      confirmPassword,
      "---------------password, confirmPassword,oldPassword from in---------------"
    );
    e.preventDefault();
    setSubmitted(true);

    if (validateFields()) {
      console.log("hy");
      return;
    }

    const fData = {
      // email: email,
      old_password: oldPassword,
      password: password,
      confirm_password: confirmPassword,
    };

    setBtnLoading(true);
    try {
      console.log(fData, "---------------fData---------------");
      const res = await UserChangePasswordApi(fData);
      if (res?.data?.success) {
        Toaster.success(res?.data?.message);
        Swal.fire({
          icon: "success",
          title: "Password Change Successful",
          text: res?.data?.message,
        });
        setEmailSent(true);
        navigate(`/edit-user-profile/${user?._id}`);
      }
    } catch (err) {
      console.log("RESETERR", err);
      // Toaster.error(err?.res?.data?.message);
      Toaster.error(err?.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="w-100">
          <div className="row login-mainsection-background">
            <div className="col-12 col-lg-12 d-flex flex-column justify-content-center">
              <div className=" login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    <div>
                      <div className="d-flex justify-content-center mb-2">
                        <Link to={"/dashboard"}>
                          <img
                            src={TElogo}
                            alt="logo"
                            style={{ height: "80px", width: "auto" }}
                          />
                        </Link>
                      </div>

                      <h4 className="login-welcome-text mt-2">
                        Change Your Password
                      </h4>

                      <form onSubmit={onLogin}>
                        <div className="mt-3">
                          <label className="mb-1 text-dark">
                            <strong>Old Password</strong>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showOldPassword ? "text" : "password"}
                              className="form-control"
                              value={oldPassword}
                              onChange={(e) =>
                                handleInputChange(e, "oldPassword")
                              }
                              placeholder="Type Your Old Password"/>
                            <span
                              className="user-eyeicon-div"
                              onClick={() =>
                                setOldShowPassword(!showOldPassword)
                              }>
                              {showOldPassword ? (
                                <IoMdEyeOff size={22} />
                              ) : (
                                <IoEye size={22} />
                              )}
                            </span>
                          </div>
                          {errors.oldPassword && (
                            <div className="text-danger fs-12">
                              {errors.oldPassword}
                            </div>
                          )}
                        </div>

                        <div className="mt-3">
                          <label className="mb-1 text-dark">
                            <strong>New Password</strong>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showNewPassword ? "text" : "password"}
                              className="form-control"
                              value={password}
                              onChange={(e) => handleInputChange(e, "password")}
                              placeholder="Type Your New Password"
                            />
                            <span
                              className="user-eyeicon-div"
                              onClick={() =>
                                setShowNewPassword(!showNewPassword)
                              }>
                              {showNewPassword ? (
                                <IoMdEyeOff size={22} />
                              ) : (
                                <IoEye size={22} />
                              )}
                            </span>
                          </div>
                          {errors.password && (
                            <div className="text-danger fs-12">
                              {errors.password}
                            </div>
                          )}
                        </div>

                        <div className="mt-3">
                          <label className="mb-1 text-dark">
                            <strong>Re-enter New Password</strong>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className="form-control"
                              value={confirmPassword}
                              onChange={(e) =>
                                handleInputChange(e, "confirmPassword")
                              }
                              placeholder="Re-enter New Password"
                            />
                            <span
                              className="user-eyeicon-div"
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }>
                              {showConfirmPassword ? (
                                <IoMdEyeOff size={22} />
                              ) : (
                                <IoEye size={22} />
                              )}
                            </span>
                          </div>
                          {errors.confirmPassword && (
                            <div className="text-danger fs-12">
                              {errors.confirmPassword}
                            </div>
                          )}
                        </div>

                        <div className="row d-flex justify-content-between mt-0 mb-0">
                          <div className="mb-3">
                            <div className="d-flex justify-content-between form-check custom-checkbox ms-1 ps-0 "></div>
                          </div>
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn text-white btn-block handle-login-btn"
                          >
                            {btnLoading && <BtnLoader />} Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserChangePassword;
